/*
 * @Author: Teemo Ding
 * @Date: 2021-08-04 17:53:32
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-04-25 08:47:05
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/config.tsx
 */
import Link from '@/src/components/Link/Link';
import { Icon } from '@/src/tools/icon';
import { replaceI18nVariables } from '@/src/tools/tools';
import { IOrderStatus } from '@/src/types/common/order';
import _ from 'lodash';
import moment from 'moment';
import React, { Fragment } from 'react';
import css from './css.module.less';
import { handleOnFormatStoreTimeAndDateWithTimezone } from '@/src/tools/tools';
// import { entireTimeFormat1 } from 'src/tools/constant';
export const breadcrumbData = (
  type,
  customerDatabaseUuid,
  customerDatabaseName,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/customerDatabase',
    name: getI18n('customerList.customerDetail_config.customerDatabase'),
  },
  {
    url: '',
    name: customerDatabaseName,
  },
  {
    url: `/customerDatabase/customerList/${customerDatabaseUuid}`,
    name: getI18n('customerList.customerDetail_config.customerList'),
  },
  {
    url: '',
    name:
      type == 'Subscriber'
        ? getI18n('customerList.customerDetail_config.subscriberDetails')
        : getI18n('customerList.customerDetail_config.customerDetails'),
  },
];

export const ordersColumns = (timezoneInUTC, { getI18n }) => [
  {
    title: replaceI18nVariables(
      getI18n(`customerList.customerDetail_config.orderTimewithTimeZone`),
      timezoneInUTC || '',
    ),
    dataIndex: 'orderTime',
    default: true,
    optional: true,
    key: 'orderTime',
    className: css.columnClass,
    minWidth: 168,
    sorter: (a, b) => moment(a.orderTime).isBefore(moment(b.orderTime)),
    render: (text) => handleOnFormatStoreTimeAndDateWithTimezone(text),
  },
  {
    title: getI18n('customerList.customerDetail_config.orderID'),
    dataIndex: 'orderId',
    default: true,
    optional: true,
    key: 'orderId',
    className: css.columnClass,
    minWidth: 240,
  },
  {
    title: getI18n('customerList.customerDetail_config.orderStatus'),
    dataIndex: 'orderStatus',
    default: true,
    optional: true,
    key: 'orderStatus',
    className: css.columnClass,
    minWidth: 120,
  },
  {
    title: getI18n('customerList.customerDetail_config.salesChannel'),
    dataIndex: 'salesChannel',
    default: true,
    optional: true,
    key: 'salesChannel',
    className: css.columnClass,
    minWidth: 200,
    render: (text) => text.name,
  },
  {
    title: getI18n('customerList.customerDetail_config.orderAmount'),
    dataIndex: 'orderAmount',
    default: true,
    optional: true,
    key: 'orderAmount',
    className: css.columnClass,
    minWidth: 256,
    render: (_, record) => (
      <Fragment>
        <div className={css.currency}>
          <span>
            {record.orderCurrencyCode} {record.orderAmount}{' '}
          </span>
          {record.reportingCurrencyCode && <Icon type='iconarrow' />}
          <span>
            {record.reportingCurrencyCode} {record.reportingAmount}
          </span>
        </div>
        {record.exhangeRate && (
          <div className={css.exhangeRate}>
            {getI18n('customerList.customerDetail_config.conversionrate')}:
            {record.exhangeRate}
          </div>
        )}
      </Fragment>
    ),
  },
  {
    title: getI18n('general.linkModule.Modal.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    key: 'action',
    align: 'center',
    className: css.columnClass,
    minWidth: 96,
    render: (text, record, index) => (
      <div className={css.viewAction}>
        {record.source == 'Portal' &&
        record.orderStatus == IOrderStatus.DRAFT ? (
          <Link to={`/orderCreate/${record.orderUuid}`}>
            {getI18n('general.view')}
          </Link>
        ) : (
          <Link to={`/order/${record.orderUuid}`}>
            {getI18n('general.view')}
          </Link>
        )}
      </div>
    ),
  },
];

export const subscriptionColumns = (
  customerDatabaseUuid,
  remove,
  timezoneInGMT,
  canDelete,
  { getI18n },
) => [
  {
    title: getI18n('customerList.customerDetail_config.subscriptionID'),
    dataIndex: 'uuid',
    default: true,
    optional: true,
    key: 'uuid',
    className: css.columnClass,
    minWidth: 320,
  },
  {
    title: replaceI18nVariables(
      getI18n(`customerList.customerDetail_config.subscribedTime`),
      timezoneInGMT || '',
    ),
    dataIndex: 'subscribedTime',
    default: true,
    optional: true,
    key: 'subscribedTime',
    className: css.columnClass,
    minWidth: 272,
    sorter: (a, b) =>
      moment(a.subscribedTime).isBefore(moment(b.subscribedTime)),
  },
  {
    title: getI18n('customerList.customerDetail_config.subscriptionEmail'),
    dataIndex: 'email',
    default: true,
    optional: true,
    key: 'email',
    className: css.columnClass,
    minWidth: 272,
  },
  {
    title: getI18n('general.linkModule.Modal.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    key: 'action',
    align: 'center',
    className: css.columnClass,
    minWidth: 208,
    render: (_, record) => (
      <div className={css.viewAction}>
        <Link
          to={`/customerDatabase/customerDetail/${customerDatabaseUuid}/${record.uuid}?type=Subscriber`}>
          {getI18n('general.view')}
        </Link>
        <span
          {...(canDelete ? {} : { style: { color: '#ccc' } })}
          onClick={() => {
            if (canDelete) {
              remove(record);
            }
          }}>
          {getI18n('general.remove')}
        </span>
      </div>
    ),
  },
];

export const consentColumns = (
  type: string,
  timezoneInGMT,
  { getI18n },
  disabled?: boolean,
  format?: string,
) => [
  {
    title: replaceI18nVariables(
      getI18n(`customerList.customerDetail_config.time`),
      timezoneInGMT || '',
    ),
    dataIndex: 'consentDate',
    default: true,
    optional: true,
    key: 'consentDate',
    className: css.columnClass,
    minWidth: 272,
    sorter: (a, b) => moment(a.consentDate).isBefore(moment(b.consentDate)),
    render: (text, record) => {
      return <span>{text}</span>;
    },
  },
  {
    title: getI18n(
      'customerList.customerDetail_config.consentToTerms&Conditions',
    ),
    dataIndex: type == 'Subscriber' ? 'termsCondition' : 'name',
    default: true,
    optional: true,
    key: type == 'Subscriber' ? 'termsCondition' : 'name',
    className: css.columnClass,
    minWidth: 640,
    ...(type == 'Subscriber' && {
      render: (text, record) => _.get(record, 'termsCondition.name', ''),
    }),
  },
  {
    title: getI18n('general.linkModule.Modal.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    align: 'center',
    key: 'action',
    className: css.columnClass,
    minWidth: 128,
    render: (text, record) =>
      disabled ? null : (
        <div className={css.viewAction}>
          <Link
            to={`/salesChannel/termsAndCondition/editor/${
              type == 'Subscriber'
                ? _.get(record, 'termsCondition.salesChannelUuid', '')
                : record.salesChannelUuid
            }/${
              type == 'Subscriber'
                ? _.get(record, 'termsCondition.uuid', '')
                : record.uuid
            }`}>
            {getI18n('general.view')}
          </Link>
        </div>
      ),
  },
];

export const customerAccountColumns = (customerDatabaseUuid, { getI18n }) => [
  {
    title: getI18n('customerList.customerDetail_config.customerID'),
    dataIndex: 'uuid',
    default: true,
    optional: true,
    key: 'uuid',
    className: css.columnClass,
    minWidth: 272,
  },
  {
    title: getI18n('customerList.customerDetail_config.firstName'),
    dataIndex: 'firstName',
    default: true,
    optional: true,
    key: 'firstName',
    className: css.columnClass,
    minWidth: 192,
  },
  {
    title: getI18n('customerList.customerDetail_config.lastName'),
    dataIndex: 'lastName',
    default: true,
    optional: true,
    key: 'lastName',
    className: css.columnClass,
    minWidth: 360,
  },
  {
    title: getI18n('customerList.customerDetail_config.action'),
    dataIndex: 'action',
    default: true,
    optional: true,
    key: 'action',
    align: 'center',
    className: css.columnClass,
    minWidth: 208,
    render: (text, record, index) => (
      <div className={css.viewAction}>
        <Link
          to={`/customerDatabase/customerDetail/${customerDatabaseUuid}/${record.uuid}`}>
          {getI18n('general.view')}
        </Link>
      </div>
    ),
  },
];
